import isString from 'lodash/isString';
import { m, AnimatePresence } from 'framer-motion';
import { alpha } from '@mui/material/styles';
import { List, Stack, Button, IconButton, ListItemText, ListItem, MenuItem } from '@mui/material';
import { fData } from '../../utils/formatNumber';
import { CustomFile, UploadSingleFileBannerProps } from './types';
import { RHFSelect } from '../hook-form';
import ImageLegacy from '../image/imageLegacy';
import IconifyLegacy from '../iconify/iconify-legacy';
import { varFade } from '../animate';

// ----------------------------------------------------------------------

const getFileData = (file: CustomFile | string) => {
  if (typeof file === 'string') {
    return {
      key: file,
    };
  }
  return {
    key: file.name,
    name: file.name,
    size: file.size,
    preview: file.preview,
  };
};

// ----------------------------------------------------------------------

export const routes: any = [
  // { url: '/benefits/products', name: 'Produtos' },
  { url: '/home#achievements-trail', name: 'Trilha de Conquistas' },
  { url: '/benefits/events', name: 'Experiências' },
  { url: '/benefits/promotions', name: 'Promoções' },
  // { url: '/benefits/coupons', name: 'Cupons' },
  { url: '/benefits/list', name: 'Benefícios' },
  // { url: '/benefits/experiences', name: 'Experiências' },
  { url: '/benefits/collectibles', name: 'Colecionáveis' },
  { url: '/benefits/forNewUsers', name: 'Benefício para novos usuários' },
  { url: '/user/myProfile', name: 'Meu Viva' },
  { url: '/user/myLevel', name: 'Meu Nível' },
  // { url: '/benefits/products/all?defaultFilter=671fd265ee8a6a8183fa10b2', name: 'Produtos Alimentação' },
  { url: '/user/pointsHowToEarn', name: 'Ganhar Pontos' },
  { url: '/user/pointsHowToUse', name: 'Usar Pontos' },
  { url: '/missions/missionsList', name: 'Missões' },
  { url: '/missions/missionCheckIn/677058674e0e4ad5a5d49fca', name: 'Missão Checkin' },
  // { url: '/missions/missionQuiz/677013f4a4a18a76bf3ae2b4', name: 'Missão Quiz' },
  // { url: '/missions/missionInvoice/676eb60f5e7b499fae255dbb', name: 'Missão NF' },
  { url: '/help/faq', name: 'Ajuda' },
];

export default function SingleFilePreview({
  showPreview = false,
  file,
  onRemove,
  onRemoveAll,
}: UploadSingleFileBannerProps) {
  const hasFile = file?.length > 0;
  return (
    <>
      <List disablePadding sx={{ ...(hasFile && { my: 3 }) }}>
        <AnimatePresence>
          {file?.map((f, idx) => {
            const { key, name, size, preview } = getFileData(f as CustomFile);
            if (showPreview) {
              return (
                <Stack key={key} direction="column">
                  <Stack direction="row">
                    <ListItem
                      component={m.div}
                      {...varFade().inRight}
                      sx={{
                        p: 0,
                        m: 0.5,
                        width: 80,
                        height: 80,
                        borderRadius: 1.25,
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'inline-flex',
                        border: (theme) => `solid 1px ${theme.palette.divider}`,
                      }}
                    >
                      <ImageLegacy
                        alt="preview"
                        src={isString(f.urlName) ? f.urlName : preview}
                        ratio="1/1"
                      />
                      <IconButton
                        size="small"
                        onClick={() => onRemove(f)}
                        sx={{
                          top: 6,
                          p: '2px',
                          right: 6,
                          position: 'absolute',
                          color: 'common.white',
                          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
                          '&:hover': {
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
                          },
                        }}
                      >
                        <IconifyLegacy icon="eva:close-fill" />
                      </IconButton>
                    </ListItem>
                    <ListItem>
                      <RHFSelect
                        name="redirectLink"
                        label="Link"
                        variant="outlined"
                        sx={{
                          width: '100%',
                          borderRadius: '3px',
                        }}
                      >
                        {routes?.map((option: any, index: number) => (
                          <MenuItem
                            key={index + 20}
                            value={option.url}
                            sx={{
                              backgroundColor: 'white',
                              '&:hover': {
                                backgroundColor: 'lightgray',
                              },
                            }}
                          >
                            {option.name}
                          </MenuItem>
                        ))}
                      </RHFSelect>
                    </ListItem>
                  </Stack>
                </Stack>
              );
            }

            return (
              <ListItem
                key={key}
                component={m.div}
                {...varFade().inRight}
                sx={{
                  my: 1,
                  px: 2,
                  py: 0.75,
                  borderRadius: 0.75,
                  border: (theme) => `solid 1px ${theme.palette.divider}`,
                }}
              >
                <IconifyLegacy
                  icon="eva:file-fill"
                  sx={{ width: 28, height: 28, color: 'text.secondary', mr: 2 }}
                />

                <ListItemText
                  primary={isString(f) ? f : name}
                  secondary={isString(f) ? '' : fData(size || 0)}
                  primaryTypographyProps={{ variant: 'subtitle2' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />

                <IconButton edge="end" size="small" onClick={() => onRemove(f)}>
                  <IconifyLegacy icon="eva:close-fill" />
                </IconButton>
              </ListItem>
            );
          })}
        </AnimatePresence>
      </List>

      {hasFile && (
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button color="inherit" size="small" onClick={onRemoveAll}>
            Remover Todos
          </Button>
        </Stack>
      )}
    </>
  );
}
